import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactTransitionGroup from "react-addons-transition-group";

interface AnimationProps extends React.Props<Animation> {
    enter?: React.CSSProperties;
    enterActive?: React.CSSProperties;
    leave?: React.CSSProperties;
    leaveActive?: React.CSSProperties;
    appear?: React.CSSProperties;
    appearActive?: React.CSSProperties;
}

export default class Animation extends React.Component<AnimationProps, {}> {

    render() {
        return (
            <ReactTransitionGroup>
                <AnimationChild
                    enter={this.props.enter}
                    enterActive={this.props.enterActive}
                    leave={this.props.leave}
                    leaveActive={this.props.leaveActive}
                    appear={this.props.appear}
                    appearActive={this.props.appearActive}
                >
                    {this.props.children}
                </AnimationChild>
            </ReactTransitionGroup>
        );
    }
}

interface AnimationChildProps extends React.Props<AnimationChild> {
    children?: React.ReactElement<any>;
    appear?: React.CSSProperties;
    appearActive?: React.CSSProperties;
    enter?: React.CSSProperties;
    enterActive?: React.CSSProperties;
    leave?: React.CSSProperties;
    leaveActive?: React.CSSProperties;
}

class AnimationChild extends React.Component<AnimationChildProps, {}> {
    render() {
        return this.props.children;
    }

    componentWillAppear(callback: any) {
        this.applyStyles(this.props.appear);
        setTimeout(callback, 0);
    }

    componentDidAppear() {
        this.applyStyles(this.props.appearActive);
    }

    componentWillEnter(callback: any) {
        this.applyStyles(this.props.enter);
        setTimeout(callback, 0);
    }

    componentDidEnter() {
        this.applyStyles(this.props.enterActive);
    }

    componentWillLeave(callback: any) {
        this.applyStyles(this.props.leave);
        setTimeout(callback, 0);
    }

    componentDidLeave() {
        this.applyStyles(this.props.leaveActive);
    }

    private applyStyles(styles: React.CSSProperties) {
        const rootEl = ReactDOM.findDOMNode(this) as HTMLElement;
        let x: string;
        for (x in styles) {
            if (styles.hasOwnProperty(x)) {
                // Dynamically copying styles, cannot be type safe
                (rootEl.style as any)[x] = styles[x];
            }
        }
    }
}

interface OpacityAnimationProps extends React.Props<OpacityAnimation> {
    duration: number;
    fadeIn?: boolean;
    fadeOut?: boolean;
}

export class OpacityAnimation extends React.Component<OpacityAnimationProps, {}> {
    static defaultProps = {
        fadeIn: true,
        fadeOut: false
    };
    render() {
        return (
            <Animation
                appear={this.props.fadeIn ? {
                    opacity: 0,
                    transition: ""
                } : {}}
                appearActive={this.props.fadeIn ? {
                    opacity: 1,
                    transition: `opacity ${this.props.duration}s cubic-bezier(0.62, 0.28, 0.23, 0.99)`
                } : {}}

                leave={this.props.fadeOut ? {
                    opacity: 1,
                    transition: `opacity ${this.props.duration}s cubic-bezier(0.62, 0.28, 0.23, 0.99)`
                } : {}}
                leaveActive={this.props.fadeOut ? {
                    opacity: 0,
                    transition: `opacity ${this.props.duration}s cubic-bezier(0.62, 0.28, 0.23, 0.99)`
                } : {}}
            >{this.props.children}</Animation>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/overlay/components/Animation.tsx
 **/